var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlusNormal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#767571",
  d: "M13.013 6.018h-5.04V.977a.977.977 0 0 0-1.955 0v5.041H.977a.977.977 0 0 0 0 1.954h5.041v5.051a.977.977 0 0 0 1.954 0v-5.05h5.051a.977.977 0 0 0 0-1.955z"
})));
export default SvgPlusNormal;